<template lang="html">
    <label class="switch" :data-cy="name">
        <input type="checkbox" v-model="inputVal" />
        <span class="slider round"></span>
    </label>
</template>

<script>
export default {
    name: "toggle-switch",
    props: ["value", "name"],
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 62px;
    height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 1px;
    height: 1px;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 28px;
    width: 28px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    top: 3px;
}

input:checked + .slider {
    background-color: $green_1;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 8px;
}

.slider.round:before {
    border-radius: 5px;
}
</style>
